<template>
    <div
        class="z-999 sm:z-40 bg-white absolute w-full h-screen mx-auto sm:pl-16 lg:px-20 right-0 opacity-95"
    >
        <router-link to="/" class="right-0 absolute p-2">
            <img
                src="images/close.png"
                class="bg-el-right p-2 h-10 w-10 rounded-full"
            />
        </router-link>
        <div class="mt-10">
            <div class="grid grid-cols-1">
                <div class="p-4 pl-10 lg:pl-32 lg:p-32 py-10 text-left">
                    <h1
                        class="text-base text-color-1 font-montserrat font-semibold mb-6"
                    >
                        Bienvenue
                    </h1>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                    Dans le contexte actuel de l’intérêt marqué pour l’utilisation de ressources énergétiques renouvelables locales,
                    le territoire Marocain constitue un gisement très important et est encore sous-exploité par manque d’information.
                    En effet, les surfaces construites tels que les toitures des bâtiments offrent un potentiel remarquable pour la valorisation de l’énergie solaire.
                    L’IRESEN conjointement avec le Green Energy Park ont développé le Cadastre Solaire qui a été mis à disposition pour la ville de Benguerir, Casablanca,
                    puis Rabat sous format d’application web. Il permet d’évaluer de façon systématique le potentiel solaire photovoltaïque sur les toitures des bâtiments.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                    Ce cadastre se base sur les données météorologiques locales et les données géographiques.
                    Ainsi, tout utilisateur aura une meilleure vision en termes de possibilités
                    d'économie sur la facture électrique et d'autonomie réalisée grâce aux installations solaires.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                    Le cadastre solaire est un outil d’aide à la décision pour les entreprises et la population, aussi bien pour des bâtiments existants que pour des projets de bâtiments futurs,
                    en redéfinissant la valeur d’un bâtiment par rapport au potentiel solaire qu’il peut fournir. C’est également un outil de communication pour la Collectivité, avec des rendus attractifs et pédagogiques.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {}
};
</script>
